<template>
  <div>
    <el-row class="container" :gutter="20">
      <!-- Filtros -->
      <el-col class="container_col_1" :span="6">
        
        <el-row style="margin-bottom:15px;">
          <el-col :xs="16" :sm="12" :xl="16">
            <div class="title">{{ $t('NAVBAR_remitos') }}</div>
          </el-col>
          
          <el-col :xs="8" :sm="12" :xl="6" class="btn-nuevo">
            <el-button class="btn" type="primary" size="small" @click="onRemitoClick" round>{{ $t('SOLICITUD_REMITO_btn_asociar_remito') }}</el-button>
          </el-col>
        </el-row>
        
        <el-row>
          <el-collapse v-model="activeNames" style="margin-bottom: 5px;">
            <el-collapse-item :title="$t('GENERAL_Busqueda_Simple')" name="1">
              <div class="filters">
                <div class="filters_item">
                  <div class="label">{{ $t('SOLICITUDES_nro_remito') }}</div>
                  <el-input
                    :placeholder="$t('SOLICITUDES_nro_remito')"
                    size="small"
                    v-model="filtros.nro_remito"
                    @input="getSolicitudesDelayed"
                  />
                </div>

                <div class="filters_item">
                  <div class="label">{{$t('SOLICITUDES_instancia')}}</div>

                  <el-select v-model="filtros.instancia" size="small" @change="getSolicitudes">
                    <el-option :value="''" :label="$t('GENERAL_OPCION_TODOS')"></el-option>
                    <el-option :value="1" :label="$t('INSTANCIA_PENDIENTE_ASOCIAR')"></el-option>
                    <el-option :value="2" :label="$t('INSTANCIA_PENDIENTE_ENVIAR')"></el-option>
                    <el-option :value="3" :label="$t('INSTANCIA_ENVIADO')"></el-option>
                    <el-option :value="4" :label="$t('INSTANCIA_PROCESO')"></el-option>
                    <el-option :value="5" :label="$t('INSTANCIA_HISTORICO')"></el-option>
                  </el-select>
                </div>

                <div class="clearFilters" @click="cleanFilters">{{$t('GENERAL_clean_filters')}}</div>
              </div>
            </el-collapse-item>
          </el-collapse>
        </el-row>
      </el-col>

      <!-- Resultados de búsqueda -->
      <el-col class="container_col_2" :span="17">
        <el-row style="margin-bottom:15px;">

          <el-col :xs="8" :sm="12"  :md="10" :lg="16" :xl="16">
            <div class="sub-title">{{$t('GENERAL_resultado')}}</div>
          </el-col>
          
          <el-col :xs="16" :sm="12" :md="14" :lg="8" :xl="8" class="pagination_container">
            <el-pagination              
              background
              small
              layout="prev, pager, next"
              :current-page="paginador.page"
              :page-count="paginador.nro_pages"
              :page-size="paginador.pageSize"
              :pager-count="5"
              @current-change="handlePageChange"
              hide-on-single-page
            ></el-pagination>
          </el-col>
        </el-row>

        <!-- Remitos -->
        <el-row>
          <el-col :span="24">
            <div class="card_list">
              <div v-if="loading" v-loading.lock="loading" class="loader"></div>
              <div
                class="card_list_item"
                v-else-if="solicitudes !== undefined && solicitudes.length > 0"
                v-for="(solicitud, index) in solicitudes"
                :key="index">
                <SolicitudCard
                  esAsociacion
                  :solicitud="solicitud"
                  @select="selectSolicitud"
                  @anular="onAnularSolicitud"
                  @desasociarRemito="onDesasociarRemito"
                />
              </div>

             <div v-else class="loader">{{$t('GENERAL_no_data')}}</div>
            </div>
          </el-col>
        </el-row>

        <!-- Paginador abajo -->
        <el-row class="paginator_bottom">
          <el-col :xs="8" :sm="12" :md="10" :lg="16" :xl="16"></el-col>
          <el-col :xs="16" :sm="12" :md="14" :lg="8" :xl="8" class="pagination_container">
            <el-pagination
              background
              small
              layout="prev, pager, next"
              :current-page="paginador.page"
              :page-count="paginador.nro_pages"
              :page-size="paginador.pageSize"
              @current-change="handlePageChange"
              :pager-count="5"
              hide-on-single-page
            ></el-pagination>
          </el-col>
        </el-row>
        
      </el-col>
    </el-row>

    <!-- ASOCIACIÓN DE REMITO -->
    <Modal v-if="showModal">
      <template v-slot:header>
        <div class="modal_title">{{ $t('SOLICITUD_REMITO_asociar_remito') }}</div>
      </template>
      <template v-slot:body>
        <div class="modal_body">
          <div class="label_modal">{{ $t('SOLICITUD_REMITO_nro_remito_input') }}:</div>

          <div>
            <el-input
              class="input_modal"
              :placeholder="$t('SOLICITUD_REMITO_nro_remito')"
              size="small"
              v-model="nro_remito_asoc"
            />
          </div>
          
        </div>
      </template>
      <template v-slot:footer>
        <div class="btn-container">
          <el-button
            type="primary"
            @click="asociarClick"
            :disabled="nro_remito_asoc === ''"
          >
            {{ $t('GENERAL_asociar') }}
          </el-button>

          <el-button class="btnBack" @click="toggleModal">{{ $t('GENERAL_cancelBtn') }}</el-button>
        </div>
      </template>
    </Modal>

    <!-- ASOCIACIÓN A REMITO -->
    <AppDialog 
      :visible="showAsociacionDialog"
      :title="$t('SOLICITUD_REMITO_confirmacion_titlo')"
      :message="asociacion_msg"
      :onClose="onCloseAsociacionConfirmation"
    />

    <!-- DESASOCIACIÓN DE REMITO -->
    <AppDialog 
      :visible="id_solicitud_a_desasociar !== undefined"
      :title="$t('SOLICITUD_REMITO_desasociar_remito_titulo')"
      :message="desasociacion_msg"
      :onClose="onCloseDesasociarConfirmation"
    />

    <!-- ANULAR SOLICITUD DE SERVICIO -->
    <AppDialog 
      :visible="id_solicitud_a_anular !== undefined"
      :title="$t('SOLICITUD_REMITO_anular_solicitud_titulo')"
      :message="anular_asociacion_msg"
      :onClose="onCloseAnularConfirmation"
    />

  </div>
</template>

<script>
  import SolicitudCard from "@/components/Cards/solicitudCard"
  import Modal from "@/components/Modal"
  import AppDialog from "../Dialog"
  import { mapState } from "vuex"
  import { showError, showSuccess } from "../Mensaje"
  import { mostrarMensajeInternacionalizado } from "../MensajeInternacionalizado/index"

  let defaultPaginador = {
    page: 1,
    pageSize: 10,
    nro_pages: 0
  };

  export default {    name: 'RemitosList',    components: { SolicitudCard, Modal, AppDialog },
    data() {
      return {
        solicitudes: undefined,
        filtros: {
          nro_remito: "",
          instancia: 1
        },
        paginador: {
          page: 1,
          pageSize: 10,
          nro_pages: 0
        },
        loading: true,
        activeNames: ["1"],

        nro_remito_asoc: "",
        showModal: false,
        showAsociacionDialog: false,
        asociacion_msg: '',

        id_solicitud_a_anular: undefined,
        anular_asociacion_msg: '',

        id_solicitud_a_desasociar: undefined,
        nro_remito_a_desasociar: undefined,
        desasociacion_msg: ''
      };
    },
    computed: {
      ...mapState({
        idUsuario: state => state.sesion.resultadoAutenticacion.IdUsuario
      })
    },
    watch: {
      solicitudes_store(newVal) {
        this.solicitudes = newVal;
      }
    },
    mounted() {
      this.getSolicitudes();
    },
    methods: {
      handlePageChange(page) {
        this.paginador.page = page;
        this.getSolicitudes();
      },

      getSolicitudes() {
        this.loading = true;

        // armo el payload
        let payload = this.filtros;
        payload.idUsuario = this.idUsuario;
        payload.page = this.paginador.page;
        payload.pageSize = this.paginador.pageSize;
        
        // busco las solicitudes
        this.$store
          .dispatch("solicitudes/getSolicitudes", payload)
          .then(data => {
            // cargo la cantidad de páginas
            this.paginador.nro_pages = data.Datos ? data.Datos.TotalPaginas : 0;

            // agrego la propiedad 'seleccionado' a los items de solicitud
            let solicitudes = data.Datos ? data.Datos.Solicitudes : [];
            solicitudes.map(sol => {
              sol.seleccionado = false;
            });
            this.solicitudes = solicitudes;
          })
          .finally(() => (this.loading = false));
         
      },

      cleanFilters() {
        // limpio los filtros
        this.filtros.nro_remito = "";
        this.filtros.instancia = 1;
        this.paginador.page = 1;

        // busco las solicitudes
        this.getSolicitudes();
      },

      getSolicitudesDelayed() {
        if (this.timer) {
          clearTimeout(this.timer);
          this.timer = null;
        }

        this.timer = setTimeout(() => {
          this.paginador = { ...defaultPaginador };
          this.getSolicitudes();
        }, 1000);
      },

      changeInstancia(value) {
        this.filtros.instancia = value;
        this.getSolicitudes();
      },

      selectSolicitud(id_sol) {
        let solicitud = this.solicitudes.filter(sol => sol.IdSolicitud == id_sol)[0];
        solicitud.seleccionado = !solicitud.seleccionado;
      },

      onAnularSolicitud(solicitud) 
      {
        // armo el mensaje a mostrar
        let mensaje = this.$t('SOLICITUD_REMITO_anular_solicitud_mensaje')
        mensaje = mensaje.replace('[nro_solicitud]', solicitud.NumeroSolicitud)
        this.anular_asociacion_msg = mensaje
        
        // guardo la solicitud a anular
        this.id_solicitud_a_anular = solicitud.IdSolicitud
      },

      onCloseAnularConfirmation(confirm) {
        
        // si confirmó el diálogo, anulo la solicitud
        if(confirm)
        {
          this.anularSolicitud(this.id_solicitud_a_anular)
        }
        
        // limpio los valores del diálogo
        this.id_solicitud_a_anular = undefined
        this.anular_asociacion_msg = ''
      },

      anularSolicitud(id_sol) 
      {
        this.$store.dispatch("solicitudes/anularSolicitud", { solicitudId: id_sol })
        .then(result => 
        {
          if (result.CodigoResultado != 0)  
          {
            mostrarMensajeInternacionalizado(result.CodigoResultado, result.DescripcionResultado)
          }
          else 
          {
            showSuccess(this.$t("GENERAL_success"));
            this.getSolicitudes()
          }
        })
      },

      onDesasociarRemito(solicitud, nro_remito)
      {
        // armo el mensaje a mostrar
        this.desasociacion_msg = this.$t('SOLICITUD_REMITO_desasociar_remito_mensaje')
        this.desasociacion_msg = this.desasociacion_msg.replace('[nro_solicitud]', solicitud.NumeroSolicitud)
        this.desasociacion_msg = this.desasociacion_msg.replace('[nro_remito]', nro_remito)

        // guardo los valores de solicitud y remito
        this.nro_remito_a_desasociar = nro_remito
        this.id_solicitud_a_desasociar = solicitud.IdSolicitud
      },

      onCloseDesasociarConfirmation(confirm) {
        if(confirm)
        {
          this.desasociarRemito(this.id_solicitud_a_desasociar, this.nro_remito_a_desasociar)
        }

        // limpio los valores de solicitud y remito
        this.nro_remito_a_desasociar = undefined
        this.id_solicitud_a_desasociar = undefined
        this.desasociacion_msg = ''
      },

      desasociarRemito(id_solicitud, nro_remito) 
      {
        this.$store.dispatch("solicitudes/desasociarRemito", { solicitudId: id_solicitud, nroRemito: nro_remito })
        .then(result => 
        {
          if (result.CodigoResultado != 0)  
          {
            mostrarMensajeInternacionalizado(result.CodigoResultado, result.DescripcionResultado)
          }
          else 
          {
            showSuccess(this.$t("GENERAL_success"));
            this.getSolicitudes()
          }
        })
      },

      toggleModal() {
        // muestro/oculto el modal
        if (this.solicitudes.filter(sol => sol.seleccionado).length)
          this.showModal = !this.showModal;
        else 
          showError(this.$t("SOLICITUD_REMITO_solicitud_no_seleccionado"));
      },

      onRemitoClick() {
        // limpio el valor de remito asociado
        this.nro_remito_asoc = "";

        // muestro el modal
        this.toggleModal();
      },

      asociarClick() {
        // oculto el modal
        this.toggleModal();

        // muestro diálogo de confirmación
        this.asociacion_msg = this.$t("SOLICITUD_REMITO_confirmacion_mensaje").replace("[nro_remito]", this.nro_remito_asoc)
        this.showAsociacionDialog = true
      },

      onCloseAsociacionConfirmation(confirm) {
        
        // si confirma llamo a la lógica de asociar remito
        if(confirm) 
        {
          this.asociarRemito()
        }

        // limpio las variales de confirmación de asociación a remito
        this.showAsociacionDialog = false
        this.asociacion_msg = ''
      },

      asociarRemito() {
        // armo el payload
        let payload = {
          idUsuario: this.idUsuario,
          nroRemito: this.nro_remito_asoc,
          solicitudesId: this.solicitudes.filter(sol => sol.seleccionado).flatMap(item => item.IdSolicitud)
        };

        // llamo a la asociación de solicitud a remitos
        this.$store.dispatch("solicitudes/asociarSolicitudes", payload)
        .then(result => {
          // verifico si el resultado es exitoso
          if (result.CodigoResultado === 0) 
          {
            let mensaje = this.$t("SOLICITUD_REMITO_exito").replace("[nro_remito]", this.nro_remito_asoc)
            showSuccess(mensaje)

            // actualizo la lista de solicitudes
            this.getSolicitudes()
          } 
          else 
          {
            mostrarMensajeInternacionalizado(result.CodigoResultado)
          }
        })
      }
    }
  }
</script>

<style>

  .el-message-box__btns {
    direction: rtl;
    text-align: center;
  }

  .el-message-box__btns > button {
    margin-left: 10px;
  }

  @media(max-width: 450px)
  {

    .el-message-box {
      width: 80%;  
    }

    .el-message-box__btns > button {
      margin-left: 0px;
      width: 100%;
    }

    .el-message-box__btns > button:last-child {
      margin-top: 10px;
    }

  }

</style>

<style scoped>
  .btn{
    font-size:10px !important;
  }

  .btn-nuevo {
    padding-right:0%;
    text-align:right;
  }
  .el-card {
    height: 100%;
  }
  .container {
    display: flex;
    margin-top:15px;
    min-height: 500px !important;
    width:  100% !important;
  }
  .pagination_container {
    text-align: right;
    padding-right:0px;
  }
  .container_col_1 .el-collapse,
  .container_col_1 .el-collapse.el-collapse-icon-position-right {
    width: 100%;
  }
  .paginator_bottom{
    margin-top:10px;
    text-align: right;
  }

  @media (max-width: 768px) {
    .container {
      flex-direction: column;
    }
    .container_col_1 {
      flex: 0 0 100% !important;
      width:100% !important;
      max-width:100% !important;
    }
    .container_col_2 {
      flex: 0 0 100% !important;
      width:100% !important;
      max-width:100% !important;
      margin-top:20px;
    }
    .btn{
    font-size:12px !important;
    }  
  }
   @media (min-width: 801px) and (max-width: 999px) {
    .container {
      flex-direction: column;
    }
    .container_col_1 {
      flex: 1;
      width:100% !important;
    }
    .container_col_2 {
      flex: 1;
      width:100% !important;
      margin-top:20px;
    }
    .btn{
    font-size:12px !important;
    }  
  }
  .card_list {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
    grid-gap: 1rem;
  }
  .card_list_item {
    position: relative;
  }
  .title {
    font-size: 18px;
    font-weight: bold;
    text-align: left;
    color: var(--main-color);
  }
  .sub-title {
    font-size: 18px;
    font-weight: bold;
    text-align: left;
    color: #999;
  }
  .filters {
    display: flex;
    flex-direction: column;
  }
  .filters_item {
    flex: 1;
    margin-bottom: 10px;
  }
  .label {
    text-align: left;
    margin-bottom: 4px;
    font-size: 14px;
  }
  .label_modal {
    margin-right: 10px;
    margin-bottom: 5px;
    font-size: 14px;
    text-align: left;
  }
  .username {
    font-size: 14px;
    font-weight: bold;
    text-align: left;
  }
  .ns_dominio {
    font-size: 12px;
    font-weight: 100;
    color: #878585;
    text-align: left;
  }
  .tag {
    float: right;
    margin-top: 7px;
  }
  .info {
    margin-top: 20px;
  }
  .greyLabel {
    font-size: 14px;
    color: #6b6b6b;
    text-align: left;
    font-weight: normal;
  }
  .blackLabel {
    font-size: 14px;
    color: black;
    text-align: left;
    margin-bottom: 5px;
    font-weight: bold;
  }
  .switch {
    margin-left: 10px;
    margin-bottom: 2px;
  }
  .clearFilters {
    color: #5aabc6;
    font-size: 14px;
    text-align: left;
    margin-top: 10px;
    cursor: pointer;
  }
  .el-card__body {
    padding: 20px 40px;
  }
  .triangleRight {
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 8px 0 8px 13.9px;
    border-color: transparent transparent transparent var(--main-color);
    position: absolute;
    left: 18px;
    top: 28px;
    cursor: pointer;
  }
  .triangleDown {
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 13.9px 8px 0 8px;
    border-color: var(--main-color) transparent transparent transparent;
    position: absolute;
    left: 18px;
    top: 28px;
    cursor: pointer;
  }
  .cardBody {
    padding-left: 25px;
  }
  .fade-enter-active {
    transition: opacity 0.5s;
  }
  .fade-leave-active {
    transition: opacity 0.1s;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }

  .soonToExpire {
    font-size: 14px;
    color: #2e2e2e;
    font-weight: bold;
    text-align: left;
    margin-top: 40px;
  }
  .el-radio-group {
    display: flex;
    flex-direction: column;
    text-align: left;
    margin-top: 14px;
  }
  .el-radio {
    line-height: 2;
  }
  .el-dropdown-link {
    cursor: pointer;
    color: #409eff;
    float: left;
    margin-top: 5px;
  }
  .el-icon-arrow-down {
    font-size: 12px;
  }
  .loader {
    margin-top: 25%;
    color: #999;
  }
  .card_list_item {
    position: relative;
  }
  .modal_title {
    font-size: 18px;
    font-weight: bold;
    color: var(--main-color);
    text-align: center;
  }
  .el-select {
    width: 100%;
  }

  @media(max-width: 360px) {

    .btn-container > button {
      width: 100%;
    }

    .btnBack {
      margin-left: 0px;
      margin-top: 10px;    
    }

  }

</style>
